var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"logo",class:_vm.type},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}}),_vm._v("\n  "+_vm._s(_vm.type !== "only" ? _vm.name : "")+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }